import React from 'react';
import { Room } from '@material-ui/icons';

/*
 Simple map marker
*/

const MainMarker = props => {
  return <Room style={{ color: '#f10030' }} />;
};

export default MainMarker;



// WEBPACK FOOTER //
// ./src/components/map/MainMarker.js